import classnames from 'classnames';
import React from 'react';

/**
 * Base dialog background is an invisible element to allow closing the dialog on background click
 * @param props DialogBackgroundProps
 */ const DialogBackground = (props)=>{
    const { className, handleClose, id, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement("div", {
        ...otherProps,
        className: classnames({
            'bf-dialog__background': true,
            [`${className}`]: !!className
        }),
        "data-testid": id ? `${id}-background` : undefined,
        onClick: ()=>handleClose(),
        role: "presentation"
    });
};

export { DialogBackground };
//# sourceMappingURL=dialog-background.js.map
